import { TrendingUp, ShieldCheck, Flame, Percent } from "lucide-react";

const items = [
  {
    icon: TrendingUp,
    title: "Margini più alti",
    text: "Nessun costo di registrazione contratto, nessuna utenza pagata, nessuna commissione OTA. Il risultato finale è una rendita netta superiore.",
  },
  {
    icon: ShieldCheck,
    title: "Sicurezza di pagamento",
    text: "Contratti strutturati, inquilini selezionati, cash-flow prevedibile mese dopo mese.",
  },
  {
    icon: Flame,
    title: "Richiesta di mercato alle stelle",
    text: "Studenti e lavoratori fuori sede: domanda in crescita a Milano e nelle principali città.",
  },
  {
    icon: Percent,
    title: "Cedolare 10% + sconto IMU*",
    text: "Fiscalità agevolata: non solo guadagni di più, paghi anche meno tasse sulla rendita.",
  },
];

export const ValueProp = () => {
  return (
    <section
      data-testid="value-prop-section"
      className="relative bg-brand-ink text-white py-24 sm:py-32 lg:py-40 overflow-hidden grain-overlay"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 relative">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <p
              data-testid="value-eyebrow"
              className="inline-flex items-center gap-3 text-xs uppercase tracking-[0.25em] font-semibold text-brand-beige"
            >
              <span className="h-px w-10 bg-brand-beige/70" />
              La soluzione ideale
            </p>
            <h2
              data-testid="value-headline"
              className="font-display text-4xl sm:text-5xl lg:text-[3.5rem] leading-[1.05] font-bold mt-8"
            >
              Affitto Transitorio: <span className="italic font-normal text-brand-beige">meno fatica, più rendita.</span>
            </h2>
            <p
              data-testid="value-paragraph"
              className="mt-8 text-lg leading-relaxed text-white/75 max-w-xl"
            >
              Non si tratta solo di incassare di più. Si tratta di <span className="text-white font-medium">tenere di più</span> a fine mese —
              con meno gestione, meno rischio e un quadro fiscale costruito per premiare chi sceglie questa formula.
            </p>
            <div className="mt-10 inline-block">
              <div className="font-display text-7xl sm:text-8xl leading-none font-black text-white">
                10<span className="text-brand-beige">%</span>
              </div>
              <div className="mt-2 text-sm uppercase tracking-[0.2em] text-white/60">
                Cedolare secca agevolata*
              </div>
              <div className="mt-3 text-xs italic text-white/45">
                *Solo su contratti a canone concordato.
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4 lg:gap-6">
            {items.map((it) => (
              <div
                key={it.title}
                data-testid={`value-item-${it.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="group relative bg-white/[0.03] border border-white/10 p-7 rounded-sm hover:bg-white/[0.06] transition-colors"
              >
                <div className="h-11 w-11 flex items-center justify-center border border-brand-beige/40 text-brand-beige rounded-sm group-hover:bg-brand-beige group-hover:text-brand-ink transition-colors">
                  <it.icon size={20} strokeWidth={1.8} />
                </div>
                <h3 className="mt-6 font-display text-2xl font-semibold text-white leading-tight">
                  {it.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-white/70">{it.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
